import * as Url from "../../api/url_helper";
import axios, { AxiosResponse } from "axios";

/* ---------- Types ---------- */

interface HttpOptions {
  withCredentials: boolean,
  headers: {
    "Content-Type": string;
  };
}

interface LoginResponse {
  // keep as unknown if API response is not finalized
  [key: string]: unknown;
}

interface AuthPayload {
  username: string;
  password: string;
  actionip: string | null;
  database: string;
  loginFrom?: string | null;
  compModuleId?: string | null;
}

type Username = string;
type Password = string;
type UserId = number | string;
type loginFrom =  string | null;
type compModuleId = string | null;

/* ---------- Helpers ---------- */
interface LicenseUpdatePayload {
  compid?: number;
  userid?: number;
  compcode?: string | null;
  compno?: string | null;
  licensekey?: string | null;
}

function httpOptions(): HttpOptions {
  return {
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      // Authorization header intentionally commented
    },
  };
}

/* ---------- Auth APIs ---------- */

export const login = async (
  username: Username,
  password: Password,
  loginFrom?: loginFrom,
  compModuleId?: compModuleId
): Promise<AxiosResponse<LoginResponse>> => {
  const actionip = sessionStorage.getItem("iPAddress");
  const database = process.env.REACT_APP_DATABASE as string;

  // if (!Url.Admin_API.AUTH_API) {
  //   window.location.reload();
  // }

  const payload: AuthPayload = {
    username,
    password,
    actionip,
    database,
    loginFrom,
    compModuleId
  };

  return axios.post(
    Url.Admin_API.AUTH_API + "Authentication",
    payload,
    httpOptions(),
  );
};

export const userLogout = async (
  username: Username,
): Promise<AxiosResponse<unknown>> => {
  sessionStorage.removeItem("currentUser");
  sessionStorage.removeItem("token");

  const actionip = sessionStorage.getItem("iPAddress");
  const database = process.env.REACT_APP_DATABASE as string;

  // return axios.post(
  //   `${Url.Admin_API.AUTH_API}UserLogout?username=${username}&actionip=${actionip}&database=${database}`,
  //   null,
  //   httpOptions()
  // );
  return axios.post(
    `${Url.Admin_API.AUTH_API}UserLogout?username=${encodeURIComponent(
      username,
    )}&actionip=${actionip ?? ""}`,
    null,
    httpOptions(),
  );
};

export const createPassword = async (
  obj: Record<string, unknown>,
): Promise<Record<string, never>> => {
  // API intentionally disabled
  return {};
  // return axios.post(
  //   Url.Admin_API.AUTH_API + "CreatePassword",
  //   obj,
  //   httpOptions()
  // );
};

export const resetPassword = async (
  userid: UserId,
  password: Password,
  actionip: string | null,
): Promise<Record<string, never>> => {
  // API intentionally disabled
  return {};
  // return axios.post(
  //   `${Url.Admin_API.AUTH_API}ResetPassword?userid=${userid}&password=${password}&actionip=${actionip}`,
  //   null,
  //   httpOptions()
  // );
};

export const userPasswordLinkDateCheck = async (
  obj: Record<string, unknown>,
): Promise<Record<string, never>> => {
  // API intentionally disabled
  return {};
  // return axios.post(
  //   Url.Admin_API.AUTH_API + "CheckExpiryDate",
  //   obj,
  //   httpOptions()
  // );
};

export const GetCurrentVersion = async (): Promise<Record<string, never>> => {
  // API intentionally disabled
  return {};
  // return axios.get(
  //   Url.Admin_API.AUTH_API + "GetCurrentVersion",
  //   httpOptions()
  // );
};

/* =========================
   License Update Function
========================= */
 
export const licenseUpdate = async (
  licensekey?: string | null,
  compno?: string | null,
  compcode?: string | null,
  userid?:  number,
  compid?:  number,
): Promise<AxiosResponse<any>> => {
  const actionip = sessionStorage.getItem("iPAddress");
  if (!Url.Admin_API.AUTH_API) {
    window.location.reload();
  }

  const payload: LicenseUpdatePayload = {
    licensekey,
    compno,
    compcode,
    userid,
    compid
  };
  debugger
 
  return await axios.post(
    `${Url.Admin_API.AUTH_API}UpdateCompanyLicense`,
    payload,
    httpOptions(),
  );
};